import { useCallback, useMemo, useState } from 'react';
import { ApiError } from '../../../lib/http/ApiError';
import { useFetch } from '../../../hooks/useFetch';
import { useNotification } from '../../notifications/hooks/useNotification';
import { createUsersApi } from '../api/usersApi';

interface UseDeleteUserResult {
  deleteUser: (id: string) => Promise<true | ApiError | Error>;
  loading: boolean;
  error: ApiError | Error | null;
}

export function useDeleteUser(): UseDeleteUserResult {
  const [client, loading] = useFetch();
  const api = useMemo(() => createUsersApi(client), [client]);
  const { notifyError } = useNotification();

  const [error, setError] = useState<ApiError | Error | null>(null);

  const deleteUser = useCallback(
    async (id: string): Promise<true | ApiError | Error> => {
      try {
        setError(null);
        await api.delete(id);
        return true;
      } catch (err) {
        const e = err as ApiError | Error;
        setError(e);
        if (ApiError.isApiError(e) && e.isServerError) notifyError(e);
        else if (!ApiError.isApiError(e)) notifyError(e);
        return e;
      }
    },
    [api, notifyError],
  );

  return { deleteUser, loading, error };
}
